import * as React from 'react';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Logo from '../assets/logo-sebrae.png';
import LogoRight from '../assets/logo-sebrae-one.svg';
import CircularProgress from '@mui/material/CircularProgress';
import VisibilityIcon from '@mui/icons-material/Visibility';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';

import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLocalStorage } from '../hooks/useLocalStorage';
import InputMask from 'react-input-mask';
import TextField from '@mui/material/TextField';
import { useForm, Controller } from 'react-hook-form';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import CustomizedDialogs from '../components/ModalAlert';
import { handleHttpError } from '../utils';
import { AES, enc } from 'crypto-js';
import encHex from 'crypto-js/enc-hex';
import padZeroPadding from 'crypto-js/pad-zeropadding';
import { useQuery } from '../hooks/useQuery';
import MuralAvisos from '../components/MuralAvisos';
import ReCAPTCHA from 'react-google-recaptcha';
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from 'react-google-recaptcha-v3';

export const CadastroPage = () => {
  const { cadastrar, setUser, login } = useAuth();
  const [loading, setLoading] = React.useState(false);
  const [loadingAviso, setLoadingAviso] = React.useState(false);
  const navigate = useNavigate();
  const [visible, setVisible] = React.useState(true);
  const [mostrarSenha, setMostrarSenha] = React.useState(false);
  const [radioValue, setRadioValue] = React.useState('PF');
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();
  const { listarAvisos } = useQuery();
  const [show, setShow] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const [avisos, setAvisos] = React.useState();
  let [searchParams, setSearchParams] = useSearchParams();
  const recaptchaRef = React.createRef();

  React.useEffect(() => {
    listar();
    if (searchParams.get('cpf') !== null) {
      setValue('login', searchParams.get('cpf'));
    }

    if (searchParams.get('cnpj') !== null) {
      setValue('cnpj', searchParams.get('cnpj'));
    }
  }, []);

  const listar = async () => {
    setLoadingAviso(true);

    const result = await listarAvisos();

    if (result && result.data) {
      setAvisos(result.data.data);
    }

    setLoadingAviso(false);
  };

  const onSubmit = async (data) => {
    const token = recaptchaRef.current.getValue();

    if (!token) return alert('Resolva o recaptcha');

    setLoading(true);

    try {
      let key = encHex.parse('0123456789abcdef0123456789abcdef');
      let iv = encHex.parse('abcdef9876543210abcdef9876543210');

      const cryptedPassword = AES.encrypt(data.senha, key, {
        iv: iv,
        padding: padZeroPadding,
      }).toString();
      await cadastrar(
        {
          name: data.name,
          cnpj:
            radioValue == 'PJ' ? data.cnpj.replace(/[^a-zA-Z0-9]/g, '') : '',
          cpf: data.login.replace(/\D/g, ''),
          senha: cryptedPassword,
          tipo: radioValue,
          recaptcha: token,
          email: data.email,
        },
        setLoading,
      );
      const result = await login({
        login: data.login.replace(/\D/g, ''),
        cnpj: radioValue == 'PJ' ? data.cnpj.replace(/[^a-zA-Z0-9]/g, '') : '',
        senha: cryptedPassword,
        tipo_pessoa: radioValue,
        tipo_acesso: 'parceiro',
      });

      if (result && result.status && result.status === 200) {
        setUser(result.data.data);
        setLoading(false);
        if (result.data.data.cnpj == null) {
          navigate(
            `/dashboard/listar-cadastros?fornecedor=${result.data.data.cpf}`,
            { replace: true },
          );
        } else {
          navigate(
            `/dashboard/listar-cadastros?fornecedor=${result.data.data.cnpj}`,
            { replace: true },
          );
        }
      }
    } catch (error) {
      setLoading(false);
      setMessage(handleHttpError(error));
      setType('error');
      setShow(true);
    }
  };

  const changeTipo = (value) => {
    setRadioValue(value);
  };

  return (
    <Grid container spacing={0}>
      <MuralAvisos />
      <Grid item sm={4}>
        <img src={Logo} />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            component="h1"
            variant="h5"
            align="left"
            color={'#00669e'}
          >
            FAZER CADASTRO
          </Typography>
          <Box style={{ width: '68%' }} sx={{ mt: 1 }}>
            <CustomizedDialogs
              content={message}
              btnTxt={type === 'success' ? 'Ir para login' : 'Ok'}
              type={type}
              onClick={() => {}}
              handleClose={setShow}
              visible={show}
            />
            <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
              <RadioGroup
                row
                value={radioValue}
                style={{ width: '100%' }}
                aria-labelledby="demo-row-radio-buttons-group-label"
                onChange={(e) => {
                  changeTipo(e.target.value);
                }}
              >
                <Grid container spacing={2} margin={0}>
                  <Grid container sm={6} item>
                    <FormControlLabel
                      style={{
                        width: '100%',
                      }}
                      checked={radioValue === 'PF'}
                      value="PF"
                      control={<Radio />}
                      label="Pessoa Física"
                    />
                  </Grid>
                  <Grid container sm={6} item>
                    <FormControlLabel
                      style={{
                        width: '100%',
                      }}
                      checked={radioValue === 'PJ'}
                      value="PJ"
                      control={<Radio />}
                      label="Pessoa Jurídica"
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
              <Controller
                name="name"
                control={control}
                defaultValue=""
                rules={{ required: 'Nome é obrigatório' }}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <TextField
                    margin="normal"
                    value={value}
                    error={error}
                    helperText={error && error.message}
                    onChange={onChange}
                    autoComplete="new-password"
                    fullWidth
                    id="name"
                    label={radioValue == 'PF' ? 'Nome' : 'Razão Social'}
                    autoFocus
                  />
                )}
              />
              <Controller
                name="email"
                control={control}
                defaultValue=""
                rules={{ required: 'Email é obrigatório' }}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <TextField
                    margin="normal"
                    value={value}
                    error={error}
                    helperText={error && error.message}
                    onChange={onChange}
                    autoComplete="new-password"
                    fullWidth
                    id="email"
                    label="E-mail"
                  />
                )}
              />
              {radioValue == 'PJ' ? (
                <Controller
                  name="cnpj"
                  control={control}
                  mask="**.***.***/****-**"
                  defaultValue=""
                  rules={{ required: 'CNPJ é obrigatório' }}
                  render={({
                    field: { onChange, onBlur, ref, value },
                    fieldState: { error },
                  }) => (
                    <InputMask
                      mask="**.***.***/****-**"
                      maskChar={'_'}
                      onBlur={onBlur}
                      onChange={onChange}
                      value={value}
                    >
                      {(inputProps) => (
                        <TextField
                          margin="normal"
                          error={error}
                          autoComplete="off"
                          helperText={error && error.message}
                          fullWidth
                          {...inputProps}
                          id="cnpj"
                          label="CNPJ"
                          autoFocus
                        />
                      )}
                    </InputMask>
                  )}
                />
              ) : null}

              <Controller
                name="login"
                control={control}
                defaultValue=""
                rules={{ required: 'CPF é obrigatório' }}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <InputMask
                    mask="999.999.999-99"
                    maskChar={''}
                    onChange={onChange}
                    value={value}
                  >
                    {(inputProps) => (
                      <TextField
                        margin="normal"
                        value={value}
                        error={error}
                        helperText={error && error.message}
                        onChange={onChange}
                        autoComplete="new-password"
                        fullWidth
                        id="login"
                        label={!visible ? 'Usuário de rede' : 'CPF'}
                        autoFocus
                      />
                    )}
                  </InputMask>
                )}
              />
              <Controller
                name="senha"
                control={control}
                defaultValue=""
                rules={{ required: 'Senha é obrigatório' }}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <OutlinedInput
                    fullWidth
                    value={value}
                    error={error}
                    type={mostrarSenha ? 'text' : 'password'}
                    helperText={error && error.message}
                    onChange={onChange}
                    placeholder="Senha"
                    autoComplete="new-password"
                    style={{ marginTop: '1rem' }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          onClick={() => {
                            setMostrarSenha(!mostrarSenha);
                          }}
                        >
                          {mostrarSenha ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                )}
              />
              <Box style={{ width: '100%', marginTop: 15 }}>
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_SITE_KEY}
                  ref={recaptchaRef}
                />
              </Box>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                style={{ backgroundColor: '#00669e' }}
                sx={{ mt: 3, mb: 2 }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  {loading ? (
                    <CircularProgress color={'inherit'} size={25} />
                  ) : (
                    <span>Cadastrar</span>
                  )}
                </Box>
              </Button>
              <Grid container sm={12} item justifyContent={'space-between'}>
                <Grid item xs={12} style={{ textAlign: 'end' }}>
                  <div>
                    <RouterLink to="/">
                      <span variant="body2">{'Voltar ao login'}</span>
                    </RouterLink>
                  </div>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
